import React, { useState } from "react";
import IAppStore from "app/IAppStore";
import { Button, Col, Container, Form, Row, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as TraderActions from "features/settings/traders/traders.actions";
import { Trader } from "features/settings/traders/trader";
import notificationService from 'common/notificationService';
import ValidationError from "common/validationError";
import { CellPhoneRegex } from "common/validation";
import ErrorList from "common/ui/ErrorList";
import useTraders from "./useTraders";

const SetTraderContactDetails: React.FC = () => {

    const [editingTrader, setEditingTrader] = useState<Trader>(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errors, setErrors] = useState<string[]>([]);
    const [editMode, setEditMode] = useState<boolean>(false);
    const [validated, setValidated] = useState<boolean>(false);

    const traders = useTraders();
    const myId = useSelector((store: IAppStore) => store.userState.internalId);
    const myTrader = traders.data.find(m => m.userId === myId);

    const dispatch = useDispatch();

    async function handleSubmit(event: any) {
        const traderForm = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();
        if (traderForm.checkValidity() === true) {
            setIsSubmitting(true);
            setErrors([]);
            try {
                await TraderActions.updateTraderCellPhone(dispatch, editingTrader, myTrader);
                setEditMode(false);
                notificationService.success('Trader phone number updated');
            }
            catch (err) {
                setErrors((err as ValidationError).errors);
            }
            finally {
                setIsSubmitting(false);
            }
        }
        setValidated(true);
    }

    function handleAbort() {
        setEditMode(false);
        setIsSubmitting(false);
        setEditingTrader(myTrader);
    }

    const toEdit = editingTrader ?? myTrader;
    return <>
        {myTrader && <Container>
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <Form.Group as={Row} className="mb-0">
                    <Form.Label className="required">Cell Phone</Form.Label>
                </Form.Group>
                <Form.Group as={Row}>
                    <Col md={editMode ? "6" : "10"} className="pl-0">
                        <Form.Control
                            type="text"
                            name="phone"
                            pattern={CellPhoneRegex.source}
                            value={toEdit.cellPhone ?? toEdit.phone}
                            onChange={(event: any) => setEditingTrader({ ...myTrader, cellPhone: event.target.value?.trim() })}
                            required
                            disabled={!editMode}
                        />
                        <Form.Control.Feedback type="invalid">Please provide a valid phone number</Form.Control.Feedback>
                    </Col>
                    <Col md={editMode ? "6" : "2"} className="px-0">
                        {editMode && <>
                            <Button variant="secondary" onClick={handleAbort}>
                                Cancel
                            </Button>&nbsp;
                            <Button variant="primary" type="submit">
                                Save
                                {isSubmitting && <Spinner animation="border" size="sm" className="set-trader-contact-save" />}
                            </Button>
                        </>}
                        {!editMode && <Button variant="primary" onClick={() => setEditMode(true)}>
                            Edit
                        </Button>}
                    </Col>
                </Form.Group>
            </Form>
            <ErrorList errors={errors} />
        </Container>}
    </>;
}

export default SetTraderContactDetails;